/**
 * Normaliza alias de variables y expresiones en un diccionario para lookup rápido.
 * Devuelve:
 * {
 *   aliasToVariable: { nombreN1: {...}, emailN1: {...} },
 *   aliasToExpresion: { codigoIdentificacion: {...}, imprimePosicion_25: {...} }
 * }
 */
export function normalizaAlias(variables = [], expresiones = []) {
  const aliasToVariable = {}
  const aliasToExpresion = {}

  variables.forEach((v) => {
    if (v.alias) aliasToVariable[v.alias] = v
  })

  expresiones.forEach((e) => {
    if (e.id) aliasToExpresion[e.id] = e
  })

  return { aliasToVariable, aliasToExpresion }
}

function resolverAliasRecursivo(expresion, aliasToVariable, aliasToExpresion) {
  return expresion.replace(/\$\{([^}]+)\}/g, (match, contenido) => {
    const limpio = contenido.trim()

    // Si ya es v: o i:, devolver tal cual
    if (/^(v:|i:)/.test(limpio)) return match

    // Si es alias de variable
    if (aliasToVariable[limpio]) {
      const v = aliasToVariable[limpio]
      return v.expresion // ya es ${v:ruta} o ${i:ruta}
    }

    // Si es alias de expresión (función guardada)
    if (aliasToExpresion[limpio]) {
      return aliasToExpresion[limpio].expresion
    }

    // No es alias → devolver intacto
    return match
  })
}

/**
 * Reemplaza alias dentro del contenido de una expresión.
 * Soporta recursión: si una expresión contiene otra, también se resuelve.
 */
export function resolverAliasDentroDeExpresion(expresion, aliasToVariable, aliasToExpresion) {

  // Reemplaza placeholders internos (${alias})
  expresion = expresion.replace(/\$\{([^}]+)\}/g, (match, contenido) => {
    const limpio = contenido.trim();

    if (/^(v:|i:)/.test(limpio)) return match;

    // Alias de variable
    if (aliasToVariable[limpio]) {
      return aliasToVariable[limpio].expresion;
    }

    // Alias de función/expresión guardada
    if (aliasToExpresion[limpio]) {
      return aliasToExpresion[limpio].expresion;
    }

    return match;
  });

  // Reemplaza alias sueltos dentro de argumentos
  expresion = expresion.replace(/\b([a-zA-Z0-9_]+)\b/g, (m, palabra) => {
    if (aliasToVariable[palabra]) return aliasToVariable[palabra].expresion;
    if (aliasToExpresion[palabra]) return aliasToExpresion[palabra].expresion;
    return palabra;
  });

  return expresion;
}
